import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ApiUtil from '../utils/apiUtils';
import BlogPage from './BlogPage';
import PageBuilderPage from './PageBuilderPage';

const SmartPageRouter = () => {
  const { slug: paramSlug } = useParams();
  const location = useLocation();
  
  // Extract slug from params or location
  const slug = paramSlug || location.pathname.substring(1);
  
  const [pageType, setPageType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const determinePageType = async () => {
      try {
        setLoading(true);
        
        // First, try to check if it's a BlogManager page
        try {
          const blogResponse = await ApiUtil.SendAsync({
            url: `/pages/${slug}`,
            method: 'GET'
          });
          
          if (blogResponse.data) {
            setPageType('blog');
            return;
          }
        } catch (blogError) {
          // Not a blog page, try PageBuilder
        }
        
        // Then, try to check if it's a PageBuilder page
        try {
          const pageBuilderResponse = await ApiUtil.SendAsync({
            url: `/page-templates/slug/${slug}`,
            method: 'GET'
          });
          
          if (pageBuilderResponse.data && pageBuilderResponse.data.success) {
            setPageType('pagebuilder');
            return;
          }
        } catch (pageBuilderError) {
          // Not a PageBuilder page either
        }
        
        // If neither, set to null (will show 404)
        setPageType(null);
        
      } catch (error) {
        setPageType(null);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      determinePageType();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className="dynamic-page-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading page...</p>
        </div>
      </div>
    );
  }

  // Render the appropriate page component based on type
  if (pageType === 'blog') {
    return <BlogPage slug={slug} />;
  } else if (pageType === 'pagebuilder') {
    return <PageBuilderPage slug={slug} />;
  } else {
    // Show 404 page
    return (
      <div className="dynamic-page-error">
        <div className="error-container">
          <h1>404 - Page Not Found</h1>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <button 
            className="back-home-btn"
            onClick={() => window.location.href = '/'}
          >
            Go Back Home
          </button>
        </div>
      </div>
    );
  }
};

export default SmartPageRouter;
